export default {
    getposts(state){
        return state.postsdata;
    },
    getmyposts(state){
        return state.myposts;
    },
    viewpost(state){
        return state.viewpost;
    },
}
